<template>
  <div
    :class="{
      'mb-5 border-b-3px pb-22px pl-22px pr-14px pt-14px shadow-[0_0_19px_rgba(0,0,0,0.16)] transition-colors duration-300 ease-in-out md:mb-30px md:p-30px': true,
      'border-b-www-color-white bg-www-color-neutral-medium text-www-color-white': darkTheme,
      'border-b-www-color-primary-lighter bg-www-color-white text-www-color-neutral-medium-dark hover:border-www-color-primary-light':
        !darkTheme,
    }"
    @mouseenter="translateUp"
    @mouseleave="translateDown"
  >
    <GeneralLink
      _type="generalLink"
      :link="link || []"
      text=""
      :class="{ 'grid w-full': true }"
    >
      <div
        :class="{
          'flex items-start justify-between': true,
        }"
      >
        <h3
          :class="{
            'text-base font-black leading-5 md:text-2xl md:leading-7': true,
          }"
        >
          {{ title }}
        </h3>
        <PtcIcon
          v-if="link"
          :class="{
            'h-5 w-25px text-sm font-bold leading-none md:text-xl': true,
            'text-www-color-primary-lighter': !darkTheme,
            'text-www-color-white': darkTheme,
          }"
          name="ptc-arrow-white"
        />
      </div>
      <p
        :class="{
          'mt-2 hidden pr-0 text-lg font-medium leading-5 md:block': true,
        }"
      >
        {{ description }}
      </p>
    </GeneralLink>
  </div>
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import type { ContentManualCard } from '~/sanity/types';
import { translateDown, translateUp } from '~/components/Molecules/Themes/Animation';

defineProps<ContentManualCard>();
const darkTheme = inject('useDarkTheme');
</script>
